"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const Icon_1 = require("../icon/Icon");
const SuperBonusBadge = ({ text }) => {
    const theme = (0, styles_1.useTheme)();
    if (!text || text < 0) {
        return null;
    }
    const iconView = ((0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: 'custom', iconName: 'icon-check', style: { fontSize: '1.8rem', color: '#000' } }));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            display: 'flex',
            flexDirection: 'row',
            height: 48,
            width: 64,
            padding: theme.spacing(1),
            borderBottomLeftRadius: 15,
            borderLeftWidth: 3,
            borderLeftColor: '#000'.getMediumEmphasis(),
            borderBottomWidth: 3,
            borderBottomColor: '#000'.getMediumEmphasis(),
            borderStyle: 'solid',
            backgroundColor: '#fdd100',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            right: 0
        } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h6", style: { color: '#000', fontWeight: 'bold' } }, { children: text })), iconView] })));
};
exports.default = SuperBonusBadge;
//# sourceMappingURL=SuperBonusBadge.js.map